import React from 'react';
import { BsHourglassSplit, BsListUl, BsBullseye } from 'react-icons/bs';

const testingData = [
  {
    icon: <BsHourglassSplit />,
    title: 'Indications for Genetic Testing',
    points: [
      'Uncertain diagnosis despite imaging',
      'Early onset or severe disease',
      'No clear family history but ADPKD is suspected',
      'Atypical features or presentation',
      'Family Planning Considerations',
    ],
  },
  {
    icon: <BsListUl />,
    title: 'What Genetic Testing Involves',
    points: [
      'Simple blood or saliva sample',
      'Analysis of PKD1, PKD2 and other genes',
      'Results interpreted by genetic specialist',
      'Comprehensive genetic counseling provided',
      'Family Implications Discussed',
    ],
  },
  {
    icon: <BsBullseye />,
    title: 'Benefits of Genetic Testing',
    points: [
      'Helps confirm or rule out ADPKD in uncertain cases', 
      'Provides clarity for family members, especially children and siblings', 
      'Guides decisions about kidney donation and family planning', 
      'May help predict disease course (PKD1 vs PKD2)',  
    ],
  },
];

const GeneticTesting = () => {
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Genetic Testing for PKD</h2>
        <p className="section-subtitle subtitle-left">
          Understanding when, why and how genetic testing can help patients and
          families
        </p>
        <div className="grid-container-3">
          {testingData.map((item, index) => (
            <div className="info-card" key={index}>
              <div className="card-header">
                <div className="card-icon">{item.icon}</div>
                <h3 className="card-title">{item.title}</h3>
              </div>
              <ul>
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeneticTesting;